import {Component} from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.styl']
})
export class AppComponent {
  title = 'app';
  isMenuHidden = true;
}



// WEBPACK FOOTER //
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/app.component.ts